<div class="contact-content">
    <div class="back-button">
        <mat-icon routerLink="/doctor/{{ routerLink }}">arrow_back</mat-icon>
    </div>
    <div>
        <h3>{{ doctorName | uppercase }} - ÚJ MUNKAKÖR HOZZÁADÁSA</h3>
    </div>
    <div class="contact-form">
        <form novalidate [formGroup]="specialityForm!">
            <div class="field-container">
                <div class="field">
                    <span>Munkakör neve</span>
                    <div class="data">
                        <input formControlName="name" id="name" class="form-control" type="text" required [(ngModel)]="speciality.name" />
                    </div>
                </div>
            </div>
            <div class="field-container">
                <div class="field">
                    <span>Orvos munkaköre</span>
                    <div class="data">
                        <input
                            formControlName="jobTitle"
                            id="jobTitle"
                            class="form-control"
                            type="text"
                            required
                            [(ngModel)]="speciality.jobTitle"
                        />
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="field-container" [ngStyle]="{ 'margin-top': '8px' }">
        <div class="field" [ngStyle]="{ 'justify-content': 'center', 'margin-top': '8px', 'margin-bottom': '8px' }">
            <div class="data" [ngStyle]="{ 'justify-content': 'center' }">
                <button
                    [ngStyle]="{ background: '#eee', border: '1px solid #0E8388', 'font-weight': 'bold', width: '100%' }"
                    [disabled]="!specialityForm?.valid"
                    (click)="addJobTitle()"
                >
                    MUNKAKÖR MENTÉSE
                </button>
            </div>
        </div>
    </div>
</div>
